export default __webpack_public_path__ + "static/media/19.7ce4ce95.png";